<template>
  <div>
    <section class="section section-cards">
      <div class="container">
        <b-tabs :multiline="true" position="is-centered" class="block" type="is-toggle">
          <b-tab-item label="Destacados">
            <div class="columns is-multiline is-vcentered">
                  <template v-for="oferta of ofertasTotales">
                    <template
                      v-if="oferta.tipoPackFoto === $constantes.ofertas.tiposPackFotos.DINAMICO && oferta.habilitadoCompleto"
                    >
                      <Producto
                        :oferta="oferta"
                        :packFoto="oferta.packFotosHabilitados[0]"
                        :key="`ofertagen-${oferta.id}`"
                      />
                    </template>
                    <template v-if="oferta.tipoPackFoto !== $constantes.ofertas.tiposPackFotos.DINAMICO && oferta.habilitadoCompleto">
                      <Producto
                        :oferta="oferta"
                        :packFoto="packFoto"
                        :key="`packfotogen-${packFoto.id}`"
                        v-for="packFoto of oferta.packFotosHabilitados"
                      />
                    </template>
              </template>
            </div>
          </b-tab-item>
          <b-tab-item
            v-for="agrupamiento of agrupamientos"
            :key="`agrupamiento-${agrupamiento.id}`"
            :label="agrupamiento.nombre"
          >
            <div class="columns is-multiline">
                <template v-for="oferta of agrupamiento.ofertas">
                  <template
                    v-if="oferta.tipoPackFoto === $constantes.ofertas.tiposPackFotos.DINAMICO && oferta.habilitadoCompleto"
                  >
                    <Producto
                      :oferta="oferta"
                      :packFoto="oferta.packFotosHabilitados[0]"
                      :key="`ofertapart-${oferta.id}`"
                    />
                  </template>
                  <template v-if="oferta.tipoPackFoto !== $constantes.ofertas.tiposPackFotos.DINAMICO && oferta.habilitadoCompleto">
                    <Producto
                      :oferta="oferta"
                      :packFoto="packFoto"
                      :key="`packfotop-${packFoto.id}`"
                      v-for="packFoto of oferta.packFotosHabilitados"
                    />
                  </template>
              </template>
            </div>
          </b-tab-item>
          <b-tab-item label="Fotolienzos" >
            <div class="columns multiline is-centered">
              <div class="column is-4">
                  <div class="card">
                    <div class="card-header">
                      <div class="card-header-title has-text-grey-dark">Proximamente</div>
                    </div>
                    <div class="card-content">
                      <figure class="image">
                        <img src="@/assets/img/productos/fotolienzo.jpg" />
                      </figure>
                    </div>
                  </div>
              </div>
            </div>
          </b-tab-item>
          <b-tab-item label="Otros" >
            <div class="columns multiline is-centered">
              <div class="column is-4">
                <a href="https://tienda.mundofotografico.com.ar">
                  <div class="card">
                    <div class="card-header">
                      <div class="card-header-title has-text-grey-dark">Productos</div>
                    </div>
                    <div class="card-content">
                      <figure class="image">
                        <img src="@/assets/img/productos/productos.jpeg" />
                      </figure>
                    </div>
                  </div>
                </a>
              </div>
              <div class="column is-4">
                  <div class="card">
                    <div class="card-header">
                      <div class="card-header-title has-text-grey-dark">Kioskos</div>
                    </div>
                    <div class="card-content">
                      <figure class="image">
                        <img src="@/assets/img/cards/2.png" />
                      </figure>
                    </div>
                  </div>
              </div>
              <div class="column is-4">
                  <div class="card">
                    <div class="card-header">
                      <div class="card-header-title has-text-grey-dark">Revelado</div>
                    </div>
                    <div class="card-content">
                      <figure class="image">
                        <img src="@/assets/img/cards/3.png" />
                      </figure>
                    </div>
                  </div>
              </div>
            </div>
          </b-tab-item>
        </b-tabs>
      </div>
    </section>
  </div>
</template>

<style lang="scss">
.section-cards {
  margin-top: 1.3rem;
}
.card {
  transition: transform 0.2s;
}
.card:hover {
  transform: scale(1.07);
}
.card {
  box-shadow: 0 0.5em 1em -0.125em grey, 0 0px 0 1px grey;
}
</style>

<script>
import Producto from '@/components/Productos/Producto.vue'

export default {
  name: 'Productos',
  components: {
    Producto
  },
  data () {
    return {
      urlImagenes: process.env.VUE_APP_URL_IMAGENES || '',
      agrupamientos: [],
      ofertasTotales: []
    }
  },
  created () {
    this.$apiService
      .getAgrupamientos()
      .then(response => {
        this.agrupamientos = response.data['hydra:member']
      })
      .catch(error => {
        this.mensajeErrorAxios(error, this)
      })
    this.$apiService
      .getOfertasOrdenGral()
      .then(response => {
        this.ofertasTotales = response.data
      })
      .catch(error => {
        this.mensajeErrorAxios(error, this)
      })
  }
}
</script>
